import { selfAxios } from "../../../../../../../axios/selfAxios.js";
async function getGetProductChannelList(params) {
  const { data } = await selfAxios.get(`/ucenterapi/ucenterapi/uc/internal/dict/getProductChannelList`, {
    params,
    _cache: true
  });
  return data == null ? void 0 : data.data;
}
export { getGetProductChannelList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/ucenterapi/uc/internal/dict/getProductChannelList/get.js